import React from 'react';

function ReceivablePurchaseOrders() {
    return <div>This page is deprecated, please navigate to the Inbound Receiving page to receive purchase orders</div>;
}

export { ReceivablePurchaseOrders };
